import { createContext, useContext } from 'react';

/**
 * 트랜지션 확장 영역의 상태를 제공하는 Context
 *
 * 트랜지션 때문에 미리 재생되거나 추가로 재생되는 확장 영역에서
 * 오디오를 음소거하고, 에셋 시작 위치를 조정하기 위해 사용됩니다.
 */
interface TransitionExtensionContextValue {
  // 현재 프레임이 확장 영역(extension area)에 있는지 여부
  isInExtensionArea: boolean;
  // target 확장으로 인한 assetStart 조정값 (초 단위, 음수)
  // target 클립이 앞으로 확장될 때 assetStart가 앞으로 이동해야 함
  assetStartDeltaInSeconds: number;
}

const defaultValue: TransitionExtensionContextValue = {
  isInExtensionArea: false,
  assetStartDeltaInSeconds: 0,
};

export const TransitionExtensionContext =
  createContext<TransitionExtensionContextValue>(defaultValue);

/**
 * 현재 프레임이 트랜지션 확장 영역에 있는지 여부를 반환합니다.
 * 확장 영역에서는 오디오가 음소거되어야 합니다.
 */
export const useIsInExtensionArea = (): boolean => {
  const context = useContext(TransitionExtensionContext);
  return context.isInExtensionArea;
};

/**
 * target 확장으로 인한 assetStart 조정값을 반환합니다.
 * VideoLayer/AudioLayer에서 trimBefore/startFrom을 조정할 때 사용합니다.
 */
export const useAssetStartDelta = (): number => {
  const context = useContext(TransitionExtensionContext);
  return context.assetStartDeltaInSeconds;
};
